module.exports = __webpack_public_path__ + "img/gallego22.aae76780.jpg";